// extracted by mini-css-extract-plugin
export default {"prev":"PrevButton_prev__Hw2zW"};